import { Button, Col, Image, Row, Typography } from "antd";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";

const ResultadosTest = () => {
  let history = useHistory();
  let location = useLocation();
  const { res } = location.state;
  const { anxiety, bad, chart, email, good, level, time } = res.data;
  console.log(anxiety);
  const { Title, Text } = Typography;
  return (
    <div>
      {location && (
        <div>
          <Image width={300} src={chart && chart} />
          <Title level={3}>Recomendación</Title>
          <Text style={{ fontSize: "20px" }} code>
            {res.data.bad}
          </Text>
          <Title level={3}>Sigue así</Title>
          <Text style={{ fontSize: "20px" }} code>
            {res.data.good}
          </Text>
          <Title level={3}>
            Nivel de ansiedad:{" "}
            <Text
              type={
                res.data.level === "leve"
                  ? "success"
                  : res.data.level === "alta"
                  ? "danger"
                  : res.data.level === "moderada"
                  ? "warning"
                  : "secondary"
              }
            >
              {res.data.level}
            </Text>
          </Title>
          <Text style={{ fontSize: "20px" }} code>
            {res.data.anxiety}
          </Text>
          <Button onClick={() => history.push("/profesionales")}>
            Escoge un profesional
          </Button>
        </div>
      )}
    </div>
  );
};

export default ResultadosTest;
